//#region react
import React, { useEffect, useMemo, useState } from 'react';
import Select from 'react-select';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { selectSelectedFlightToView, setSelectedFlightToView } from "_redux/slices/timeline/selected-task";
import { getPassengerFlightList, selectGetPassengerFlightListStatus, selectPassengerFlightList } from '_redux/slices/timeline/flight-information-list';
import { getOutboundFlights, getInboundFlights } from '_redux/slices/timeline/flight-information-list';
import { selectDefaultArrivalCheckInLocation, selectTimelineDate } from "_redux/slices/timeline/timeline-control";
import { selectFirebaseInfo } from "_redux/slices/main-screen/user";
import { patchFlightSchedule, resetPatchflightFlags, selectPatchFlightStatus } from '_redux/slices/flights/flight-information';
import { selectPickUpLocations } from '_redux/slices/timeline/timeline-areas';
import { selectUsedTheme } from '_redux/slices/timeline/theme';
import { arrivalPaxCheckIn, resetArrivalPaxCheckInFlags, resetUnRejectPaxFlags, selectArrivalPaxCheckInStatus, selectUnRejectPaxStatus, unRejectPax } from '_redux/slices/timeline/timeline-data';
import { selectRejectReasonsByType } from '_redux/slices/timeline/reject-reasons';
// components
import { CustomSpinner } from '_components/atoms';
import FlightFeedUpdates from './flight-feed-updates';

// styles 
import { Spacing, Colors } from '_styles';

// tremor
import { Subtitle } from "@tremor/react";
import moment from 'moment';

//icons
import { MdLockOpen } from "react-icons/md";
import { MdLockOutline } from "react-icons/md";

import { Button, Form, Card } from 'react-bootstrap';
import { GRAY_LIGHT, GRAY_DARK, TEXT_COLOR } from '_styles/colors';

//utils
import { getAssistanceString, getPaxStatus, getRejectReasonLabel, hhmm, processName, setHHmm } from '_utils/functions';
import { getDate } from "_utils/functions";


//#endregion

//#region render functions
const RowValue = ({ title, value, showUnRejectBtn = false, passenger = null, unRejectType = null }) => {
    const dispatch = useDispatch();
    const dbUser = useSelector(selectFirebaseInfo);
    const unRejectPaxStatus = useSelector(selectUnRejectPaxStatus);                // UnReject passenger Status

    useEffect(() => {
        if (unRejectPaxStatus == "succeeded") {
            dispatch(resetUnRejectPaxFlags());
        }
    }, [unRejectPaxStatus]);

    const handleUnRejectPax = () => {
        // if job has originalBookingId then choose the originalBookingId else _id
        let bookingId = passenger?.originalBookingId ? passenger?.originalBookingId : passenger?._id;
        if (bookingId) {
            dispatch(unRejectPax({
                iata: dbUser.details.authority,
                body: {
                    bookingsIDS: [bookingId],
                    unRejectType: unRejectType
                }
            }));
        };
    }
    return (
        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", marginBottom: Spacing.SCALE_12, flex: 1 }}>
            <div style={{ flex: 1 }}>
                <Subtitle>{title}</Subtitle>
                <p>{value}</p>
                {showUnRejectBtn && (
                    <Button variant="outline-primary" size="sm"
                        onClick={handleUnRejectPax}
                        loading={unRejectPaxStatus === "loading"}
                    >
                        Un Reject
                    </Button>
                )}
            </div>
        </div>
    )
};

const summaryGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    rowGap: Spacing.SCALE_12,
    columnGap: Spacing.SCALE_48,
    marginTop: Spacing.SCALE_16,
    justifyContent: "center",
    alignItems: "center",
};

const rowGridStyle = {
    display: "grid",
    gridTemplateColumns: "repeat(5, 1fr)",
    columnGap: Spacing.SCALE_24,
    rowGap: Spacing.SCALE_8,
    padding: "8px 0",
    borderBottom: "1px solid #e0e0e0",
};
//#endregion

const ViewFlight = () => {

    //#region redux
    const dispatch = useDispatch()
    const selectedFlightToView = useSelector(selectSelectedFlightToView);
    const patchFlightStatus = useSelector(selectPatchFlightStatus);
    const passengerFlightList = useSelector(selectPassengerFlightList);                             // selected flight passenger list 
    const dbUser = useSelector(selectFirebaseInfo);                                                 // logged in user
    const timelineDate = useSelector(selectTimelineDate);                                           // select timeline Date
    const pickUpLocations = useSelector(selectPickUpLocations);                     // pickup locations selector
    const defaultArrivalCheckInLocation = useSelector(selectDefaultArrivalCheckInLocation);
    const usedTheme = useSelector(selectUsedTheme);
    const arrivalPaxCheckInStatus = useSelector(selectArrivalPaxCheckInStatus);
    const getPassengerFlightListStatus = useSelector(selectGetPassengerFlightListStatus);
    //#endregion
    const manualLockInitial = !!selectedFlightToView?.manualLock;
    const unRejectPaxStatus = useSelector(selectUnRejectPaxStatus);

    const rejectReasons = useSelector((state) => selectRejectReasonsByType(state, "ALL"))
    // prefer the “displayed” time as the base when locked, otherwise show feed time
    const displayedIso = manualLockInitial
        ? selectedFlightToView?.operationInfo?.time
        : selectedFlightToView?.flightFeedTime

    //#region local states
    const [operatingStatus, setOperatingStatus] = useState("On Time");                              // early / delay / on time
    const [flightStatus, setFlightStatus] = useState("Scheduled");                                  // landed / departed badge text
    const [formattedTime, setFormattedTime] = useState('');
    const [statusTime, setStatusTime] = useState('');
    const [originalTime, setOriginalTime] = useState("");
    const [showTimeDifference, setShowTimeDifference] = useState(false);
    const [flightFeedTime, setFlightFeedTime] = useState("");
    const [manualLock, setManualLock] = useState(manualLockInitial);
    const [tempTime, setTempTime] = useState(hhmm(displayedIso))
    const [passengerCnt, setPassengerCnt] = useState(0);
    const [passengerToCheckIn, setPassengerToCheckIn] = useState(null);
    const [selectedCheckInLocation, setSelectedCheckInLocation] = useState(null);
    const [passengerToCheckOut, setPassengerToCheckOut] = useState(null);
    //#endregion

    //#region useEffect
    // set landed flight
    useEffect(() => {
        if (!selectedFlightToView) return
        const status = selectedFlightToView?.operationInfo?.status;
        const statusType = selectedFlightToView?.operationInfo?.statusType;
        const statusTime = selectedFlightToView?.operationInfo?.time;
        setOperatingStatus(selectedFlightToView?.operatingStatus);
        setStatusTime(selectedFlightToView?.operationInfo?.time);
        setOriginalTime(selectedFlightToView?.originalFlightTime);
        setManualLock(selectedFlightToView.manualLock)
        setFlightFeedTime(selectedFlightToView.flightFeedTime ?? "")

        if (status === "Actual" && dbUser.details.authority !== "ORK") {
            if (statusType === "Out of Blocks" || statusType === "Taken Off" || statusType === "Take Off" || statusType === "On Blocks" || statusType === "Touchdown" || statusType === '') {
                // set landed / departed badge text based on flight type
                if (selectedFlightToView?.type === "departure") {
                    setFlightStatus("Departed");
                }
                if (selectedFlightToView?.type === "arrival") {
                    setFlightStatus("Landed");
                }
            } else {
                setFlightStatus("Scheduled");
            };
        } else if (status === "Actual" && dbUser.details.authority == "ORK") {
            if (statusType === "Out of Blocks" || statusType === "Taken Off" || statusType === "Take Off" || statusType === "On Blocks" || statusType === "Touchdown" || statusType === '') {

                const currentDate = new Date();
                const statusDate = new Date(selectedFlightToView?.date);
                // add 5 minutes to statusDate
                statusDate.setHours(new Date(statusTime).getHours());
                statusDate.setMinutes(new Date(statusTime).getMinutes());
                statusDate.setMinutes(statusDate.getMinutes() + 5);
                // compare the dates
                if (statusDate < currentDate) {
                    if (selectedFlightToView?.type === "departure") {
                        setFlightStatus("Departed");
                    }
                    if (selectedFlightToView?.type === "arrival") {
                        setFlightStatus("Landed");
                    }
                } else {
                    setFlightStatus("Scheduled");
                }
            } else {
                setFlightStatus("Scheduled");
            };
        } else {
            setFlightStatus("Scheduled");
        };
        if (status && status !== "Actual" && statusTime) {
            const currentDate = new Date();
            const statusDate = new Date(statusTime);
            // add 5 minutes to statusDate
            statusDate.setMinutes(statusDate.getMinutes() + 5);
            // compare the dates
            if (statusDate < currentDate) {
                if (selectedFlightToView?.type === "departure") {
                    setFlightStatus("Departed");
                }
                if (selectedFlightToView?.type === "arrival") {
                    setFlightStatus("Landed");
                }
            } else {
                setFlightStatus("Scheduled");
            }

        }
    }, [selectedFlightToView]);

    useEffect(() => {
        if (statusTime && statusTime.length > 0) {
            const time = moment(new Date(statusTime)).format("HH:mm");
            setFormattedTime(time);
        }
        if (statusTime && statusTime.length > 0 && originalTime && originalTime.length > 0) {
            // check if the status time and original time are different
            if (moment(new Date(statusTime)).format("HH:mm") !== moment(new Date(originalTime)).format("HH:mm")) {
                setShowTimeDifference(true);
            } else {
                setShowTimeDifference(false);
            }
        }
    }, [statusTime, originalTime]);

    // after patch flight success, refetch flight list & reset selected flight
    useEffect(() => {
        if (patchFlightStatus === "succeeded") {
            const date = getDate(timelineDate);
            dispatch(setSelectedFlightToView(null))
            dispatch(resetPatchflightFlags())
            dispatch(getOutboundFlights({ iata: dbUser.details.authority, date: date }))
            dispatch(getInboundFlights({ iata: dbUser.details.authority, date: date }))
        }
    }, [patchFlightStatus]);

    useEffect(() => {
        if (unRejectPaxStatus == "succeeded") {
            dispatch(resetUnRejectPaxFlags());
            handleRefreshFlightList();
        }
    }, [unRejectPaxStatus]);

    // set default check in location
    useEffect(() => {
        if (defaultArrivalCheckInLocation && Array.isFullArray(pickUpLocations)) {
            const defaultLocation = pickUpLocations?.find(loc => loc?._id === defaultArrivalCheckInLocation);
            if (defaultLocation) {
                setSelectedCheckInLocation({
                    value: defaultLocation?._id ?? "",
                    label: defaultLocation?.title ?? ""
                });
            }
        }
    }, [defaultArrivalCheckInLocation, pickUpLocations]);

    // set passenger count
    useEffect(() => {
        if (Array.isArray(passengerFlightList)) {
            setPassengerCnt(passengerFlightList.length);
        }
    }, [passengerFlightList]);

    useEffect(() => {
        if (arrivalPaxCheckInStatus === "succeeded" || arrivalPaxCheckInStatus === "failed") {
            dispatch(resetArrivalPaxCheckInFlags());
            setPassengerToCheckIn(null);
            setPassengerToCheckOut(null);
        }
        if (arrivalPaxCheckInStatus === "succeeded") {
            handleRefreshFlightList();
        }
    }, [arrivalPaxCheckInStatus]);

    // reset patch flight flags on unmount
    useEffect(() => {
        dispatch(resetPatchflightFlags());
        dispatch(resetArrivalPaxCheckInFlags());
        setPassengerToCheckIn(null);
    }, []);

    //#endregion

    //#region functions

    //PATCH1: lock & save manual time
    const lockAndSave = () => {
        const id = selectedFlightToView._id;
        const newManualTimeISO = setHHmm(
            selectedFlightToView?.operationInfo?.time || selectedFlightToView?.flightFeedTime || statusTime,
            tempTime
        );

        const payload = {
            id,
            body: {
                manualLock: true,
                operationInfo: {
                    ...selectedFlightToView.operationInfo,
                    time: newManualTimeISO, // user-chosen time (manual)
                },
                flightFeedTime: statusTime, // last feed time
            },
        };

        dispatch(patchFlightSchedule(payload));
        setManualLock(true);
    };

    // PATCH:2 unlock & resume feed time, use old approach
    const unlock = () => {
        const id = selectedFlightToView._id;

        const payload = {
            id,
            body: {
                manualLock: false,
                // immediately set op time back to feed time (optional; or omit and let server/feed update)
                operationInfo: {
                    ...selectedFlightToView.operationInfo,
                    time: selectedFlightToView?.flightFeedTime || statusTime,
                },
                flightFeedTime: statusTime,
            },
        };

        dispatch(patchFlightSchedule(payload));
        setManualLock(false);
        // also reflect UI picker back to the feed time
        setTempTime(hhmm(selectedFlightToView?.flightFeedTime || statusTime));
    };

    const onPrimaryClick = () => (manualLock ? unlock() : lockAndSave());

    const getAssistedCount = (type) => {


        switch (type) {
            case "departure":
                return passengerFlightList?.filter(pax => pax?.selectDeparturePaxStatus === "collected")?.length ?? 0;
            case "boarding":
                return passengerFlightList?.filter(pax => pax?.selectBoardingPaxStatus === "boarded")?.length ?? 0;
            case "ramp":
                return passengerFlightList?.filter(pax => pax?.selectRampPaxStatus === "collected")?.length ?? 0;
            case "arrival":
                return passengerFlightList?.filter(pax => pax?.selectArrivalPaxStatus === "collected")?.length ?? 0;

            default:
                return 0;
        }
    }


    const handleCheckIn = (pax) => {
        setPassengerToCheckIn(pax)
    };

    const handleCheckOut = (pax) => {
        setPassengerToCheckOut(pax)
        dispatch(arrivalPaxCheckIn({
            bookingId: pax?._id,
            body: {
                type: "checkOut",
            }
        }));
    };

    const handleCheckInConfirmation = () => {
        if (passengerToCheckIn?.arrivalPaxCheckIn) {
            handleCheckOut(passengerToCheckIn)
        } else {
            if (selectedCheckInLocation) {
                dispatch(arrivalPaxCheckIn({
                    bookingId: passengerToCheckIn?._id,
                    body: {
                        type: "checkIn",
                        locationId: selectedCheckInLocation?.value,
                        locationTitle: selectedCheckInLocation?.label,
                    }
                }));
            }

        }
    };

    const handleRefreshFlightList = () => {
        const type = "inbound";
        const iata = selectedFlightToView?.arrivalAirport
        dispatch(getPassengerFlightList({
            flightNumber: selectedFlightToView?.flightNumber,
            departureDate: selectedFlightToView?.date,
            iata,
            type
        }))
    };



    //#endregion

    const handleUnRejectPax = (passenger) => {
        // if job has originalBookingId then choose the originalBookingId else _id
        let bookingId = passenger?.originalBookingId ? passenger?.originalBookingId : passenger?._id;
        if (bookingId) {
            dispatch(unRejectPax({
                iata: dbUser.details.authority,
                body: {
                    bookingsIDS: [bookingId],
                }
            }));
        };
    }

    const PassengerRow = (passenger) => {
        const name = processName(passenger.name);
        const assistance = getAssistanceString(passenger.assistance);
        const isDeparture = passenger?.flightConfirmationDetails?.origin === dbUser.details.authority;

        const isRejectedArrPax = passenger?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalPax");
        const isRejectedDepPax = passenger?.paxRejection?.find((paxRejection) => paxRejection?.type === "departurePax");
        const isRejectedArrJourney = passenger?.paxRejection?.find((paxRejection) => paxRejection?.type === "arrivalJourney");


        return (
            <>
                <RowValue title="Name" value={name} />
                <RowValue title="Assistance" value={assistance} />
                <RowValue
                    title={isDeparture ? "Pre-Board Status" : "Ramp Status"}
                    value={getPaxStatus(passenger, isDeparture ? "preBoard" : "ramp", rejectReasons)}
                    showUnRejectBtn={getPaxStatus(passenger, isDeparture ? "preBoard" : "ramp", rejectReasons)?.startsWith("Rejected")}
                    passenger={passenger}
                    unRejectType={isDeparture ? "preBoard" : "ramp"} />
                <RowValue
                    title={isDeparture ? "Boarding Status" : "Arrival Status"}
                    value={getPaxStatus(passenger, isDeparture ? "boarding" : "arrival", rejectReasons)}
                    showUnRejectBtn={getPaxStatus(passenger, isDeparture ? "boarding" : "arrival", rejectReasons)?.startsWith("Rejected")}
                    passenger={passenger}
                    unRejectType={isDeparture ? "boarding" : "arrival"} />

                {((isDeparture && isRejectedDepPax?.type) || (!isDeparture && isRejectedArrPax?.type)) &&
                    <div>
                        <Button
                            variant="outline-primary"
                            onClick={() => handleUnRejectPax(passenger)}
                            loading={unRejectPaxStatus === "loading"}
                        >
                            Un Reject
                        </Button>
                        <p>{isDeparture ? getRejectReasonLabel(rejectReasons, isRejectedDepPax?.reason) : getRejectReasonLabel(rejectReasons, isRejectedArrPax?.reason)}</p>


                    </div>
                }

                {passenger?.flightConfirmationDetails?.destination === dbUser.details.authority && !passenger?.rejectedPax && !isRejectedArrPax && !isRejectedArrJourney &&
                    <Button
                        variant={passenger?.arrivalPaxCheckIn ? "outline-danger" : "primary"}
                        onClick={() => passenger?.arrivalPaxCheckIn ? handleCheckOut(passenger) : handleCheckIn(passenger)}
                        style={{
                            minWidth: "100%",
                            fontWeight: '600',
                            height: "fit-content"
                        }}
                    >
                        {passenger?.arrivalPaxCheckIn ? arrivalPaxCheckInStatus === "loading" && passengerToCheckOut?._id === passenger?._id ? <CustomSpinner /> : "Check Out" : "Check In"}
                    </Button>
                }
            </>

        )
    }

    return (
        <div style={{ marginBottom: Spacing.SCALE_16 }}>

            {/* Flight Information */}
            <div style={{ marginBottom: Spacing.SCALE_24 }}>
                <Subtitle>Flight Information</Subtitle>
                <hr />
                <div
                    style={summaryGridStyle}
                >
                    <RowValue title="Flight Number" value={selectedFlightToView?.flightNumber ?? ""} />
                    <RowValue title="Departure" value={selectedFlightToView?.departureAirport ?? ""} />
                    <RowValue title="Arrival" value={selectedFlightToView?.arrivalAirport ?? ""} />
                    <RowValue title="Aircraft Registration" value={selectedFlightToView?.aircraftRegistration ?? ""} />

                    <RowValue title="Type" value={selectedFlightToView?.type ? selectedFlightToView?.type?.toUpperCase() : ""} />
                    <RowValue title="Terminal" value={selectedFlightToView?.terminal ?? "N/A"} />
                    <RowValue title="Gate" value={selectedFlightToView?.gate ?? "N/A"} />
                    <RowValue title="Stand" value={selectedFlightToView?.stand ?? "N/A"} />

                </div>
            </div>

            {/* Operation Info */}
            <div style={{ marginBottom: Spacing.SCALE_24 }}>
                <Subtitle>Operation Info</Subtitle>
                <hr />
                <div
                    style={summaryGridStyle}
                >
                    <RowValue title="Operation Status" value={operatingStatus ? operatingStatus?.toUpperCase() : ""} />
                    <RowValue title="Flight Status" value={flightStatus ? flightStatus?.toUpperCase() : ""} />
                    <RowValue title="Flight Time" value={formattedTime ? formattedTime : ""} />
                    {showTimeDifference && <RowValue title="Original Flight Time" value={originalTime ? moment(new Date(originalTime)).format('HH:mm') : ""} />}

                </div>
                <Card style={{
                    border: `1px solid ${GRAY_LIGHT}`,
                    borderRadius: '8px',
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                    backgroundColor: 'white',
                    marginTop: Spacing.SCALE_16
                }}>
                    <Card.Header style={{
                        backgroundColor: manualLock ? '#28a745' : '#ffc107',
                        color: 'white',
                        padding: Spacing.SCALE_12,
                        borderRadius: '8px 8px 0 0',
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center'
                    }}>
                        <p style={{ margin: 0, fontSize: '16px', fontWeight: '600' }}>
                            {manualLock ? 'Time Locked' : 'Time Unlocked'}
                        </p>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            {manualLock ? (
                                <MdLockOutline style={{ fontSize: 20 }} />
                            ) : (
                                <MdLockOpen style={{ fontSize: 20 }} />
                            )}
                        </div>
                    </Card.Header>

                    <Card.Body style={{ padding: Spacing.SCALE_16 }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: Spacing.SCALE_16,
                            marginBottom: Spacing.SCALE_16
                        }}>
                            <div style={{ flex: 1 }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: GRAY_DARK,
                                    marginBottom: '4px',
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.5px'
                                }}>
                                    Current Time
                                </div>
                                <div style={{
                                    fontSize: '18px',
                                    fontWeight: '600',
                                    color: TEXT_COLOR
                                }}>
                                    {hhmm(selectedFlightToView?.operationInfo?.time)}
                                </div>
                            </div>

                            {!manualLock && (
                                <div style={{ flex: 1 }}>
                                    <div style={{
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        color: GRAY_DARK,
                                        marginBottom: '4px',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px'
                                    }}>
                                        New Time
                                    </div>
                                    <Form.Control
                                        type="time"
                                        value={tempTime}
                                        step={60}
                                        onChange={(e) => setTempTime(e.target.value)}
                                        style={{
                                            maxWidth: 150,
                                            fontSize: '16px',
                                            fontWeight: '500'
                                        }}
                                    />
                                </div>
                            )}
                        </div>

                        <Button
                            variant={manualLock ? "outline-danger" : "primary"}
                            onClick={onPrimaryClick}
                            disabled={patchFlightStatus === "loading"}
                            style={{
                                minWidth: 150,
                                fontWeight: '600'
                            }}
                        >
                            {patchFlightStatus === "loading" ? (
                                <CustomSpinner />
                            ) : (
                                manualLock ? 'Unlock Time' : 'Lock Time'
                            )}
                        </Button>
                    </Card.Body>
                </Card>
            </div>

            {/* Passenger Info */}
            <div style={{ marginBottom: Spacing.SCALE_24 }}>
                <Subtitle>Passenger Info</Subtitle>
                <hr />
                <div style={summaryGridStyle}>
                    <RowValue title="Passenger Count" value={passengerCnt ?? 0} />
                    {/* <RowValue title="Assisted" value={`${assisted}/${passengerCnt}` ?? "0/0"} /> */}
                    <RowValue title={selectedFlightToView?.type === "departure" ? "Pre-Board Assisted" : "Ramp Assisted"}
                        value={getAssistedCount(selectedFlightToView?.type === "departure" ? "departure" : "ramp")} />
                    <RowValue title={selectedFlightToView?.type === "departure" ? "Boarding Assisted" : "Arrival Assisted"}
                        value={getAssistedCount(selectedFlightToView?.type === "departure" ? "boarding" : "arrival")} />


                </div>
                <div style={{ marginTop: Spacing.SCALE_14 }}>
                    {getPassengerFlightListStatus === "loading" ? <CustomSpinner /> : passengerFlightList.map((passenger, idx) => (
                        <div key={idx} style={{ borderBottom: "1px solid #e0e0e0" }}>
                            <div
                                style={{ ...rowGridStyle, alignItems: 'baseline' }}
                            >
                                <PassengerRow {...passenger} />

                            </div>
                            <div>
                                {passengerToCheckIn?._id === passenger?._id &&
                                    <div className='mt-4 mb-3' style={{ display: 'flex', gap: Spacing.SCALE_12, alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div style={{ display: 'flex', gap: Spacing.SCALE_12, alignItems: 'center' }}>
                                            <Form.Label style={{ color: Colors.PRM_LIGHT_BLUE }}>{"Check In Location"}</Form.Label>
                                            <Select
                                                value={selectedCheckInLocation}
                                                onChange={(selectedOption) => {
                                                    setSelectedCheckInLocation(selectedOption);
                                                }}
                                                options={pickUpLocations?.map(loc => ({
                                                    value: loc._id,
                                                    label: loc.title
                                                }))}
                                                placeholder={"Choose Location "}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minWidth: "180px",
                                                        borderRadius: "5px",
                                                        backgroundColor: usedTheme.BACKGROUND_COLOR,
                                                        borderColor: usedTheme.BORDER_COLOR,
                                                        color: usedTheme.TEXT_COLOR,
                                                    }),
                                                    placeholder: (provided) => ({
                                                        ...provided,
                                                        color: usedTheme.TEXT_COLOR,
                                                    }),
                                                    singleValue: (provided) => ({
                                                        ...provided,
                                                        color: usedTheme.TEXT_COLOR,
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        backgroundColor: usedTheme.BACKGROUND_COLOR,
                                                        borderColor: usedTheme.BORDER_COLOR,
                                                        color: usedTheme.TEXT_COLOR
                                                    }),
                                                    option: (provided, state) => ({
                                                        ...provided,
                                                        backgroundColor: state.isFocused
                                                            ? usedTheme.BORDER_COLOR
                                                            : usedTheme.BACKGROUND_COLOR,
                                                        color: usedTheme.TEXT_COLOR,
                                                        cursor: 'pointer',
                                                    }),
                                                }}
                                                isClearable
                                            />

                                        </div>
                                        <Button
                                            variant={"outline-primary"}
                                            onClick={handleCheckInConfirmation}
                                            disabled={!selectedCheckInLocation?.value || arrivalPaxCheckInStatus === "loading"}
                                            style={{
                                                minWidth: 150,
                                                fontWeight: '600'
                                            }}
                                        >
                                            {arrivalPaxCheckInStatus === "loading" ? <CustomSpinner /> : "Confirm"}
                                        </Button>
                                    </div>
                                }
                            </div>
                        </div>
                    ))}
                </div>

            </div>

            {/* feed updates */}
            <div>
                <FlightFeedUpdates />
            </div>
        </div>
    );
};

export default ViewFlight;
